module.exports = __webpack_public_path__ + "static/media/usability.fa9053ac.png";